import React, { createContext, useContext, useState, useRef } from 'react';

const TabNavigationContext = createContext();

export function TabNavigationProvider({ children }) {
  const [tabStates, setTabStates] = useState({});
  const scrollPositions = useRef({});
  
  const saveTabState = (tabPath, location) => {
    setTabStates(prev => ({
      ...prev,
      [tabPath]: {
        pathname: location.pathname,
        search: location.search,
        timestamp: Date.now()
      }
    }));
  };
  
  const getTabState = (tabPath) => {
    return tabStates[tabPath] || null;
  };
  
  const saveScrollPosition = (tabPath, position) => {
    scrollPositions.current[tabPath] = position;
  };
  
  const getScrollPosition = (tabPath) => {
    return scrollPositions.current[tabPath] || 0;
  };
  
  return (
    <TabNavigationContext.Provider value={{
      saveTabState,
      getTabState,
      saveScrollPosition,
      getScrollPosition
    }}>
      {children}
    </TabNavigationContext.Provider>
  );
}

export function useTabNavigation() {
  const context = useContext(TabNavigationContext);
  if (!context) {
    throw new Error('useTabNavigation must be used within TabNavigationProvider');
  }
  return context;
}